module.exports = __webpack_public_path__ + "static/media/bhc.d142b90a.png";